import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import * as ItemTypes from "../../redux/items/types"
import { Alert, Button, ButtonGroup } from "react-bootstrap"
import { DckActionCreators, DckSelectors } from "dck-redux"
import { browserHistory } from "react-router"
import FontAwesome from "react-fontawesome"
import BundleDetailForm from "./BundleDetailForm"
import Authenticated from "../../lib/Authenticated"
import { blockingFetchService } from "../../lib/blockingFetch"
import apiServerApi from "../../redux/sagas/apiServerApi"
import CustomBreadCrumb from "../fragments/CustomBreadCrumb"
import './style.css'
import UpdateBundleStatus from "./UpdateBundleStatus"

class DetailBundle extends Component {

  state = {
    shouldChangeStatus: false,
    runningFix: false,
    fixDone: false,
    error: null,
  }

  authenticated = new Authenticated()
  isAdmin = this.authenticated.isAdmin()
  isAccountant = this.authenticated.isAccountant()
  isAdminOrAccountant = this.isAdmin || this.isAccountant

  componentWillMount() {
    const { setCurrentBundleId, params, currentBundle, loadBundles } = this.props
    setCurrentBundleId(params.id)
    if(!currentBundle) {
      loadBundles()
    }
  }

  resubmitBundleInFineract = bundleId => {

    this.setState({
      runningFix: true,
      fixDone: false,
      error: null,
    })

    blockingFetchService(
      accessToken => apiServerApi.triggerBundleRecording(accessToken, bundleId),
      _ => this.setState({ fixDone: true }),
      error => this.setState({ error: error.text }),
      _ => this.setState({ runningFix: false })
    )
  }

  handleChangeStatus = () => this.setState({
    shouldChangeStatus: true,
  })

  closeChangeStatus = () => this.setState({
    shouldChangeStatus: false,
  })

  checkBundleRecording = bundle => {

    const { fixDone, runningFix, error } = this.state
    if(bundle.fineractId !== 0 || fixDone || !this.isAdmin) return null

    return <Alert bsStyle="warning">
    { runningFix
      ? <span><FontAwesome name='clock-o'/> Running ..</span>
      : <span>
        { error ? error : 'An error occurred while recording the bundle.' } &nbsp;
        <span className="reloadSave" onClick={() => this.resubmitBundleInFineract(bundle.id)}
          title="Repair">
          Please click to repair <FontAwesome name='refresh'/>
        </span>
      </span>
    }
    </Alert>
  }

  renderBtnGroup = ({ id, active, collateralDisabled }) => (
    <ButtonGroup justified>

      <Button href="#" bsStyle={ active ? 'warning' : 'info' } title={ active ? 'Disable' : 'Enable' }
        onClick={ this.handleChangeStatus } disabled={ !this.isAdmin }>
        <FontAwesome name={ active ? 'lock' : 'unlock' } /> { active ? 'Disable' : 'Enable' }
      </Button>

      <Button href="#" bsStyle="primary"
        disabled={ collateralDisabled }
        title={ collateralDisabled ? 'Cannot be updated. Collateral has been removed!' : 'Update this bundle' }
        onClick={() => browserHistory.push(`/bundles/${id}/update`)}>
        <FontAwesome name='pencil' /> Update
      </Button>

      <Button href="#" title='Create a new bundle'
        onClick={() => browserHistory.push('/bundles/add')}>
        <FontAwesome name='plus-circle' /> New Bundle
      </Button>
    </ButtonGroup>
  )

  renderContent = (bundle, setBundle, shouldChangeStatus) => (
    <div>
      <CustomBreadCrumb activeText='Bundles' data={[{ url: '/bundles', title: 'Bundles' }]} />

      { this.checkBundleRecording(bundle) }

      <BundleDetailForm
        bundle={ bundle } 
        header={ this.isAdminOrAccountant ? this.renderBtnGroup(bundle) :  null }
      />

      <UpdateBundleStatus
        bundleId={ bundle.id } 
        active={ bundle.active }
        setBundle={ setBundle }
        show={ shouldChangeStatus }
        close={ this.closeChangeStatus }
      />
    </div>
  )

  render() {
    const { currentBundle, setBundle } = this.props,
    { shouldChangeStatus } = this.state
    return currentBundle 
      ? this.renderContent(currentBundle, setBundle, shouldChangeStatus)
      : <p>Loading ..</p>
  }
}

DetailBundle.propTypes = {
  currentBundle: PropTypes.object,
  params: PropTypes.object.isRequired,
}

const mapStateToProps = (state, ownProps) => {

  const currentBundle = DckSelectors.selectItemById(
    state,
    ItemTypes.Bundle,
    ownProps.params.id
  ),

  bundles = DckSelectors.selectAllItems(state, ItemTypes.Bundle)
  return { currentBundle, bundles }
},

mapDispatchToProps = dispatch => ({

  setCurrentBundleId: id => dispatch(DckActionCreators.itemMakeActive(ItemTypes.Bundle, id)),

  loadBundles: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.Bundle)),

  setBundle: (id, data) => dispatch(DckActionCreators.itemSet(ItemTypes.Bundle, id, data)),
})

export default connect(mapStateToProps, mapDispatchToProps)(DetailBundle)



// WEBPACK FOOTER //
// ./src/components/Bundles/Detail.js